
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

var $89f90b3d45ea9cd3$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"oVoOe\",\"SpaceSettingsNavigationPortal.8b1b9c5b.js\",\"bU3dV\",\"CopySpacePermissionsAndDefaultPermissions.d227172d.js\",\"eMbU0\",\"SpaceSelector.880286ea.js\",\"3wN5D\",\"ExternalSpaceLozenge.f992c250.js\",\"kC80R\",\"esm.7399a977.js\",\"h3ABO\",\"esm.dc8ab43b.js\",\"4Nzvy\",\"manual-triggers-modal.71f03a03.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.ef2af5ea.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.fea73d48.js\",\"7EorR\",\"vendors~editor_atlaskit_md.124fde90.js\",\"iFdoJ\",\"simpleHasher.d52c6e06.js\",\"i8eeg\",\"simpleHasher.runtime.f87dc3ae.js\",\"9jjvO\",\"main.e905cac5.js\",\"7cABH\",\"emoji.c301da09.js\",\"2vAWg\",\"emoji.runtime.2f77383c.js\",\"hogcU\",\"component-lazy.d0028dda.js\",\"foy8I\",\"FullPageEditorComponent.36dd0c5e.js\",\"jYUNl\",\"FullPageEditorComponent.runtime.e2f9117a.js\",\"jXx9i\",\"NativeCollabComponent.5e274adb.js\",\"ffEVr\",\"vendors~editor_icon.f597614a.js\",\"6aTYS\",\"SpaceSelector.ed3ca1a3.js\",\"lJJQ8\",\"ViewChangesDialog.e8425838.js\",\"8OiWl\",\"ChangesDiff.a64b1265.js\",\"lKP6d\",\"GetTheDetailsYouNeedDark.bbe9839d.gif\",\"4Yi9K\",\"GetTheDetailsYouNeedLight.9900190e.gif\",\"dtpmo\",\"SpaceSelector.ce8265d6.js\",\"6wr18\",\"vendors~editor_icon.d614ee58.js\",\"5tmW9\",\"NativeCollabComponent.d745cab0.js\",\"jYUNl\",\"FullPageEditorComponent.runtime.e2f9117a.js\",\"2vAWg\",\"emoji.runtime.2f77383c.js\",\"i8eeg\",\"simpleHasher.runtime.f87dc3ae.js\",\"4yUSc\",\"PremiumLozenge.6931dbeb.js\",\"ePA5l\",\"Lozenge.6e0cd0ae.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"1yVM6\",\"UpgradeEditionButton.b130a456.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.9c87904d.js\",\"5pvpJ\",\"datasourceTableView.686437f9.js\",\"6XCf4\",\"LearnMoreButton.cf13a7ea.js\",\"cEqm7\",\"ShareButton.fa50351f.js\",\"7pxAs\",\"EndUserRequestUpgradeModal.1c3723b6.js\",\"7JvFY\",\"CopySpacePermissionsForLegacyNewSpace.e19c566d.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.9c87904d.js\",\"9LX74\",\"searchNoResults.7be90ed3.svg\"]"));


$parcel$global.rlb("e4mQI")
//# sourceMappingURL=SpaceSettingsNavigationPortal.runtime.67607e17.js.map
